/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
// Functions
import users from './modules/users'
import evouchers from './modules/evouchers'
import locale from './modules/locale'
import entities from './modules/entities'
import settings from './modules/settings'
import ad from './modules/ad'
Vue.use(Vuex)
// Create a new store
const store = new Vuex.Store({
  modules: {
    ad,
    users,
    evouchers,
    locale,
    entities,
    settings
  }
})

export default store
